// extracted by mini-css-extract-plugin
module.exports = {"animated":"e_dd","dots":"e_ed"};